<template>
    <div class="train-detail-container mainContainer bgGray pb20">
        <div class="w11">
            <bread-crumb firstPath="/pcViews/learn" firstNav="在线学习" secondPath="/pcViews/learn/train" secondNav="教育培训" :breadcrumbText="trainDetailObj.name"></bread-crumb>
            <!-- 培训班基础信息 -->
            <div class="train-main-info">
                <div class="train-main-info-left">
                    <img src="~assets/images/temporary/d_training.png" class="train-cover" alt="">
                    <div class="train-main-info-content">
                        <h4>{{trainDetailObj.name}}</h4>
                        <div class="train-time">
                            <div>
                                <p>开始时间：</p>
                                <span>{{trainDetailObj.startTime}}</span>
                            </div>
                            <div class="ml20">
                                <p>结束时间：</p>
                                <span>{{trainDetailObj.endTime}}</span>
                            </div>
                        </div>
                        <div class="train-price-mode">
                            <div>
                                <p>授课方式：</p>
                                <span>线上</span>
                            </div>
                            <div class="ml20">
                                <p>价格：</p>
                                <span class="salePrice" v-if="trainDetailObj.trainSignup">￥{{trainDetailObj.trainSignup.salePrice}}</span>
                            </div>
                            <div class="ml20">
                                <p>培训班状态：</p>
                                <span class="salePrice" >{{trainDetailObj.classroomStatus=='1' ? '未结班' : '已结班'}}</span>
                            </div>
                        </div>
                        <!-- <div class="train-complete-c">
                            <p>完成条件：</p>
                            <div>
                                <span>1.完成全部课程学时范围内60.00学时,获得培训班成绩50.00分。</span>
                                <span>2.通过全部考试,获得培训班成绩50.00分。</span>
                            </div>
                        </div> -->
                        <div class="payBtn" v-if="trainDetailObj.isBuy == '0' && trainDetailObj.isLearn === 'true' && trainDetailObj.classroomStatus === '1'" @click="enterTrainOrder">立即购买</div>
                    </div>
                </div>
                <div class="train-main-info-right">
                    <div class="train-score-condition">
                        <div class="t-condition-title">信息汇总</div>
                        <div class="t-condition-status">
                            <div class="t-c-status-news">
                                <img src="~assets/images/temporary/train1.png" alt="">
                                <div>
                                    <div>
                                        <p>{{trainDetailObj.totalPeriod}}</p>
                                        <span>学时</span>
                                    </div>
                                    <h4>总共</h4>
                                </div>
                            </div>
                            <div class="t-c-status-news">
                                <img src="~assets/images/temporary/train2.png" alt="">
                                <div>
                                    <div>
                                        <p>{{trainDetailObj.learnedPeriod}}</p>
                                        <span>学时</span>
                                    </div>
                                    <h4>已学</h4>
                                </div>
                            </div>
                            <div class="t-c-status-news">
                                <img src="~assets/images/temporary/train3.png" alt="">
                                <div>
                                    <div>
                                        <p>{{trainDetailObj.bxkCredit}}</p>
                                        <span>分</span>
                                    </div>
                                    <h4>必修学分</h4>
                                </div>
                            </div>
                            <div class="t-c-status-news">
                                <img src="~assets/images/temporary/train4.png" alt="">
                                <div>
                                    <div>
                                        <p>{{trainDetailObj.xxkCredit}}</p>
                                        <span>分</span>
                                    </div>
                                    <h4>选修学分</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="train-complete">
                        <div class="t-current-score">
                            <div class="t-current-score-n">
                                <p>当前得分：</p>
                                <span>{{trainDetailObj.score}}</span>
                                分
                            </div>
                            <div class="t-current-score-r pointer">
                                <i class="el-icon-refresh-right"></i>
                                <span @click="refreshAchievement">刷新成绩</span>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <!-- 培训班通知公告 -->
            <div class="train-notice-box">
                <div class="train-notice-icon" @click="enterNoticeList">
                    <i class="el-icon-message"></i>
                    <span>公告</span>
                </div>
                <div class="train-notice-carousel">
                    <el-carousel height="56px" direction="vertical" indicator-position="none" :interval="6000">
                        <el-carousel-item v-for="item in noticeList" :key="item.id">
                            <div class="carousel-text" @click="enterNoticeDetail(item.id)">
                                <p class="ellipsis">{{item.title}}</p>
                                <span>{{ item.updateDate }}</span>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <!-- 培训班对应的课程 -->
            <div class="train-course-container">
                <div class="train-course-header">
                    <div class="train-course-h-tabs">
                        <div class="t-c-tab" :class="{'active' : activeIndex == 0}" @click="activeIndex = 0">全部课程</div>
                        <div class="t-c-tab" :class="{'active' : activeIndex == 1}" @click="activeIndex = 1">班级成员</div>
                    </div>
                    <div class="train-course-search" v-if="activeIndex == 0">
                        <el-input
                            placeholder="请输入课程名进行搜索"
                            v-model.trim="courseName"
                            size="small"
                        >
                            <el-button
                                slot="append"
                                icon="el-icon-search"
                                @click="courseQuery"
                            ></el-button>
                        </el-input>
                    </div>
                    <!-- <div v-if="activeIndex == 1" class="courseMore">更多></div> -->
                </div>
                <!-- 课程信息 -->
                <div class="t-course-container" v-if="activeIndex == 0">
                    <div class="train-course-filter">
                        <div class="t-c-filter-status">
                            <div  class="t-c-filter-statusl">
                                <div class="courseType active">全部课程({{trainDetailObj.courseCount}})</div>
                                <!-- <el-tooltip class="item" effect="dark" content="不少于40学时" placement="bottom">
                                    <div class="courseType" :class="{'active': courseType == 1}">必修课</div>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="不少于20学时" placement="bottom">
                                    <div class="courseType" :class="{'active': courseType == 2}">选修课</div>
                                </el-tooltip> -->
                            </div>
                            <div  class="t-c-filter-statusr">
                                <span :class="{'active' : finishStatus == ''}" @click="courseStateQuery('')">全部</span>
                                <el-divider direction="vertical"></el-divider>
                                <span :class="{'active' : finishStatus == '2'}" @click="courseStateQuery('2')">未学习</span>
                                <el-divider direction="vertical"></el-divider>
                                <span :class="{'active' : finishStatus == '1'}" @click="courseStateQuery('1')">未完成</span>
                                <el-divider direction="vertical"></el-divider>
                                <span :class="{'active' : finishStatus == '0'}" @click="courseStateQuery('0')">已完成</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="coursePageObj.total > 0">
                        <div class="trainCourseList">
                            <div class="trainCourseItem" v-for="course in courseList" :key="course.id" @click="enterCourseDetail(course)">
                                <img src="~assets/images/temporary/d_course.png" class="trainCourseItemImg" alt="">
                                <div class="t-course-info">
                                    <div class="t-course-name ellipsis">{{course.name}}</div>
                                    <!-- <div class="t-conrse-greet">
                                        <div>
                                            <img src="~assets/images/index/sUserImg.jpg" alt="">
                                            <span>0</span>
                                        </div>
                                        <div>
                                            <img src="~assets/images/index/hotImg.jpg" alt="">
                                            <span>热度：0</span>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="t-course-progress">
                                    <div class="t-course-progress-c">
                                        <el-progress :percentage="Number(course.finishRatio)"  :color="progressColor(course.finishRatio)"></el-progress>
                                    </div>
                                    <div class="t-course-status">{{finishStr(course.finishStatus)}}</div>
                                </div>
                            </div>
                        </div>
                        <!-- 分页器 -->
                        <div class="page_box pb20">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size="coursePageObj.size"
                                :background="true"
                                :total="coursePageObj.total"
                                @current-change="courseCurrentChange"
                            >
                            </el-pagination>
                        </div>
                    </div>
                    <div v-else>
                        <el-empty description="暂无课程"></el-empty>
                    </div>
                </div>
                <!-- 班级成员 -->
                <div class="t-course-member" v-else>
                    <div v-if="studentsPageObj.total>0">
                        <div class="t-course-member-list">
                            <div class="t-course-member-item" v-for="student in studentList" :key="student.id">
                                <img :src="studentHeadImg(student.avatar)" alt="">
                                <p class="ellipsis">{{student.name}}</p>
                            </div>
                        </div>
                        <!-- 分页器 -->
                        <div class="page_box pb20">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size="studentsPageObj.size"
                                :background="true"
                                :total="studentsPageObj.total"
                                @current-change="studentCurrentChange"
                            >
                            </el-pagination>
                        </div>
                    </div>
                    <div v-else>
                        <el-empty description="暂无班级成员"></el-empty>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from "components/contents/breadCrumb/BreadCrumb"

import { PcCookie, Key } from "@/utils/cookie";

import { getTrainDetail, getCategoryCourse, getTrainStudents, getCategoryNotifyList, checkGxkSignup } from "api/train"

export default {
    components:{ BreadCrumb },
    computed:{
        //学员头像
        studentHeadImg(){
            return function (avatar){
                const img = require("@/assets/images/personal/defaultHeadImg.png")
                let hImg = avatar == '' ? img : avatar;
                return hImg;
            }
        },
        //课程进度条颜色
        progressColor(){
            return function(per){
                const perNum = per.substring(0,per.length-1);
                const color = Number(perNum) == 100 ? "#1989fa" : "#e6a23c"
                return color
            }
        },
        //课程进度条
        percentage(){
            return function(per){
                const perNum = per.substring(0,per.length-1);
                return parseInt(perNum)
            }
        },
        //课程完成状态
        finishStr(){
            return function(finishStatus){
                let fStr = '';
                if(finishStatus == '0'){
                    fStr = '已完成'
                }else if(finishStatus == '1'){
                    fStr = '未完成'
                }else if(finishStatus == '2'){
                    fStr = '未学习'
                }
                return fStr
            }
        }
    },
    data(){
        return {
            breadcrumbText:"2022年度内蒙古自治区专业技术人员继续教育（建筑类）专业课",
            courseName:"",//课程搜索名称
            activeIndex:0,//全部课程 ： 0  班级成员 1
            finishStatus:'', //课程学习状态 '' 是全部 '0' 已完成 '1'未完成 '2'未学习
            trainId:null,//培训班ID
            trainDetailObj:{},//培训班详情
            hasNews:false,
            coursePageObj:{//培训班课程分页器
                page: 1,
                size: 8,
                total: 0,
            },
            courseList:[],//课程集合,
            studentsPageObj:{//学员分页器
                page: 1,
                size: 30,
                total: 0,
            },
            studentList:[],//学员集合
            msg:'',
            noticeList:[],//通知公告集合
        }
    },
    created(){
        this.trainId = this.$route.query.trainId;
        this.feachTrainDetail();
        this.feachTrainNoticeList();
        this.fetchTrainCourse();
        this.fetchTrainStudents();
    },
    methods:{
        //刷新当前成绩
        refreshAchievement(){
            this.feachTrainDetail();
        },
        //获取培训班学员信息
        fetchTrainStudents(){
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getTrainStudents(sessionId,this.trainId,this.studentsPageObj.page,this.studentsPageObj.size).then(res => {
                let { success, errorCode, body, msg } = res;
                if (success && errorCode == "2000") {
                    const { count,  list} = body.data;
                    this.studentsPageObj.total = count;
                    this.studentList = list;
                }else{
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                }
            })
        },
        //进入课程详情
        async enterCourseDetail(course){
            const isBuy = this.trainDetailObj.isBuy;
            const isLearn = this.trainDetailObj.isLearn;
            const courseId = course.id;
            const trainId = this.trainId;
            if(isBuy == '0'){
                this.$message({
                    message: '购买培训班课程后，方可进行学习！',
                    type: 'warning'
                });
            }else if(isLearn != "true"){
                this.$message({
                    message: this.msg,
                    type: 'warning'
                });
            }else if(this.trainDetailObj.classroomStatus == '0'){
                this.$message({
                    message: '该培训班已结班，不能进行学习了！',
                    type: 'warning'
                });
            }else{
                const sessionId = PcCookie.get(Key.jsessIdKey);
                const res = await  checkGxkSignup(sessionId,this.trainDetailObj.id)
                if(res.errorCode == '5000'){
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }else{
                    this.$router.push({
                        path:'/pcViews/learn/course',
                        query:{
                            courseId,
                            trainId
                        }
                    })
                }
            }
        },
        //获取培训班课程
        fetchTrainCourse(){
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getCategoryCourse(sessionId,this.coursePageObj.page,this.coursePageObj.size,this.trainId,this.courseName,this.finishStatus).then(res => {
                let { success, errorCode, body, msg } = res;
                if (success && errorCode == "2000") {
                    const { count,  list} = body.data;
                    this.coursePageObj.total = count;
                    this.courseList = list;
                }else{
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                }
            })
        },
        //进入购买培训班订单页
        async enterTrainOrder(){
            const sessionId = PcCookie.get(Key.jsessIdKey);
            const res = await  checkGxkSignup(sessionId,this.trainDetailObj.id)
            if(res.errorCode == '5000'){
                this.$message({
                    message: res.msg,
                    type: 'error'
                });
            }else{
                this.$router.push({
                    path:'/pcViews/order-payment',
                    query:{
                        trainId:this.trainId
                    }
                })
            }

        },
        //进入通知公告详情
        enterNoticeDetail(noticeId){
            this.$router.push({
                path:'/pcViews/learn/train-notice-details',
                query:{
                    noticeId
                }
            })
        },
        //进入通知公告列表
        enterNoticeList(){
            this.$router.push({
                path:'/pcViews/learn/train-notice',
                query:{
                    trainId:this.trainId
                }
            })
        },
        //获取培训班通知公告
        feachTrainNoticeList(){
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getCategoryNotifyList(sessionId,this.trainId,1,6).then(res => {
                let { success, errorCode, body, msg } = res;
                if (success && errorCode == "2000") {
                    this.noticeList = body.data.list;
                }else{
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                }
            })
        },
        //获取培训班详情
        feachTrainDetail(){
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getTrainDetail(sessionId,this.trainId).then(res => {
                let { success, errorCode, body, msg } = res;
                if (success && errorCode == "2000") {
                    this.trainDetailObj = body.data;
                    this.msg = msg;
                }else{
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                }
            })
        },
        //课程分页器切换
        courseCurrentChange(current){
            this.coursePageObj.page = current;
            this.fetchTrainCourse();
        },
        //用课程名搜索
        courseQuery(){
            this.fetchTrainCourse();
        },
        //课程完成状态查询
        courseStateQuery(state){
            this.coursePageObj.page = 1;
            this.coursePageObj.total = 0;
            this.finishStatus = state;
            this.fetchTrainCourse();
        },
        //学员分页器查询
        studentCurrentChange(current){
            this.studentsPageObj.page = current;
            this.fetchTrainStudents();
        }
    }
}
</script>

<style lang="less" scoped>
.carousel-text{
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    p{
        min-width: 200px;
        max-width:600px;
    }
    span{
        margin-left:120px;
    }
}
.train-notice-carousel{
    padding-left: 26px;
    flex: 1;
    height: 100%;
}
.train-notice-icon{
    display: flex;
    flex-direction: row;
    align-items: center;
    color:#fff;
    cursor: pointer;
    i{
        font-size: 36px;
    }
    span{
        margin-left: 20px;
        font-size: 22px;
        line-height: 1;
    }
}
.train-notice-box{
    margin-top:15px;
    padding: 0 60px;
    height:56px;
    background: linear-gradient(to right,#7651c1,#6452fe);
    display: flex;
    flex-direction: row;
    align-items: center;
}
.t-course-member-item{
    width: 97px;
    height: 106px;
    margin: 0 5px 10px;
    border: solid 1px #ddd;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    >img{
        width: 66px;
        height: 66px;
        border-radius: 50%;
    }
    p{
        width: 100%;
        margin-top: 5px;
        font-size: 14px;
        color: #818181;
        text-align: center;
    }
}
.t-course-member-list{
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
}
.t-course-member{
    padding: 0 15px;
}
.pb20{
    padding-bottom: 20px;
}
.t-course-progress{
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    .t-course-progress-c{
        flex: 1;
    }
    .t-course-status{
        font-size: 12px;
        color: #7e7e7e;
        line-height: 1;
    }
}
.t-conrse-greet{
    height: 34px;
    border-bottom: 1px dashed #e7e7e7;
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div{
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        color: #7e7e7e;
        span{
            line-height: 1;
        }
        img{
            margin: -2px 4px 0 0;
        }
    }
}
.t-course-name{
    font-size: 16px;
    color: #7e7e7e;
}
.t-course-info{
    padding: 10px 10px 0;
}
.trainCourseItemImg{
    height: 146px;
    width: 100%;
}
.trainCourseItem{
    width: 259px;
    height: 212px;
    border: 1px solid #d9dee7;
    margin: 0 4px 20px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
}
.trainCourseList{
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
}
.t-c-filter-statusr{
    display: flex;
    align-items: center;
    span{
        cursor: pointer;
    }
    span.active{
        color: #0647aa;
    }
}
.t-c-filter-statusl{
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .courseType{
        width: 96px;
        height: 32px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .courseType.active{
        color: #fff;
        background: #0647aa;
    }
}
.t-c-filter-status{
    height: 48px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 14px;
    color: #000;
}
.train-course-filter{
    padding: 0 20px;
}
.courseMore{
    color: #818181 ;
    font-size: 14px;
    cursor: pointer;
}
.train-course-search{
    width: 246px;
    height: 100%;
    background: yellow;
}
.train-course-h-tabs{
    height: 46px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .t-c-tab{
        margin-right: 20px;
        font-size: 16px;
        color: #000;
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        border-bottom: solid 2px #fff;
    }
    .t-c-tab.active{
        color: #0647aa;
        border-color: #0647aa;
    }
}
.train-course-header{
    border-bottom: 1px solid #e7e7e7;
    background-color: #fff;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.train-course-container{
    margin-top: 15px;
    background: #fff;
}
.t-current-score-n,.t-current-score-r{
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 26px;
}
.t-current-score{
    height: 42px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    background: linear-gradient(to right,#7651c1,#6452fe);
    color: #fff;
    font-size: 14px;
}
.t-condition-status{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .t-c-status-news{
        margin-bottom: 22px;
        width: 49%;
        height: 80px;
        position: relative;
        >img{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        >div{
            position: absolute;
            left: 114px;
            top: 0;
            z-index: 3;
            height: 100%;
            color: #fff;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            div{
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 24px;
                p{
                    font-weight: bold;
                    font-size: 18px;
                }
                span{
                    margin-left: 4px;
                    font-size: 14px;
                }
            }
            h4{
                font-weight: normal;
            }
        }
    }
}
.t-condition-title{
    margin:  0 0 30px;
    line-height: 26px;
    color: #818181 ;
    font-size: 16px;
    font-weight: bold;
}
.train-main-info-right{
    padding: 0 20px;
    width: 500px;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.train-complete-c{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    div{
        flex: 1;
        display: flex;
        flex-direction: column;
        span{
            line-height: 20px;
        }
    }
}
.payBtn{
    margin: 26px auto 0;
    width: 178px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    border-radius: 18px;
    cursor: pointer;
    background: #ff8e09;
}
.salePrice{
    font-size: 22px;
    color: #ff8d1b;
    font-weight: bold;
}
.ml20{
    margin-left: 20px;
}
.train-price-mode{
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    div{
        line-height: 26px;
        display: flex;
        flex-direction: row;
    }
}
.train-time{
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    div{
        line-height: 26px;
        display: flex;
        flex-direction: row;
    }
}
.train-main-info-content{
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.3);
    z-index: 3;
    width: 100%;
    height: 100%;
    padding: 0 20px;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    >h4{
        line-height: 32px;
        font-size: 22px;
        font-weight: bold;
    }

}
.train-cover{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.train-main-info-left{
    position: relative;
    width: 560px;
    height: 100%;
}
.train-main-info{
    height: 352px;
    display: flex;
    justify-content: space-between;
}
</style>
